import { converterDataHoraBr } from "_utils/Data";
import { StatusBadge } from "components/StatusBadge";
import { FaEye } from "react-icons/fa";
import {
  IColunaTabelaPadrao,
  TabelaPadrao,
} from "../../components/TabelaPadrao";
import {
  chaveStatusAutorizacao,
  chaveStatusProducao,
  labelStatus,
  varianteStatus,
} from "../../constants/status";
import { ILoteSolicitacao } from "../../interfaces/ILoteSolicitacao";
import { DirecaoOrdenacao, IOrdenacao } from "../../interfaces/IOrdenacao";
import { rotuloFornecedor, rotuloPrensas } from "../../utils/rotulosLote";

const SEM_VALOR = "—";

function badgeStatus(chave: string) {
  return (
    <StatusBadge label={labelStatus(chave)} variant={varianteStatus(chave)} />
  );
}

interface IProps {
  lotes: ILoteSolicitacao[];
  totalRegistros: number;
  carregando: boolean;
  limite: number;
  reiniciarPaginacao: boolean;
  onMudarPagina: (pagina: number) => void;
  onMudarLimite: (limite: number) => void;
  onOrdenar: (campo: string, direcao: DirecaoOrdenacao) => void;
  onExportar: () => void;
  exportando: boolean;
  paginaInicial: number;
  ordenacaoInicial: IOrdenacao;
  onVisualizar: (id: number) => void;
}

export function ListarLotes({
  lotes,
  totalRegistros,
  carregando,
  limite,
  reiniciarPaginacao,
  onMudarPagina,
  onMudarLimite,
  onOrdenar,
  onExportar,
  exportando,
  paginaInicial,
  ordenacaoInicial,
  onVisualizar,
}: IProps) {
  const colunas: IColunaTabelaPadrao<ILoteSolicitacao>[] = [
    {
      chave: "lote",
      titulo: "Lote",
      selector: ({ id }) => id,
      sortable: true,
      sortField: "lote",
      width: "90px",
    },
    {
      chave: "pdi",
      titulo: "PDI",
      selector: ({ pdi }) => pdi ?? SEM_VALOR,
      sortable: true,
      sortField: "pdi",
      width: "150px",
    },
    {
      chave: "fornecedor",
      titulo: "Fornecedor",
      selector: ({ fornecedor }) => rotuloFornecedor(fornecedor),
      sortable: true,
      sortField: "fornecedor",
    },
    {
      chave: "prensa",
      titulo: "Prensa",
      selector: ({ prensas }) => rotuloPrensas(prensas) ?? SEM_VALOR,
      sortable: true,
      sortField: "prensa",
    },
    {
      chave: "criadoEm",
      titulo: "Criado em",
      selector: ({ criadoEm }) => converterDataHoraBr(criadoEm) ?? SEM_VALOR,
      sortable: true,
      sortField: "criadoEm",
      width: "190px",
    },
    {
      chave: "usuario",
      titulo: "Usuário",
      selector: ({ usuario }) => usuario ?? SEM_VALOR,
      sortable: true,
      sortField: "usuario",
    },
    {
      chave: "placas",
      titulo: "Placas",
      selector: ({ qtdPlacas }) => qtdPlacas,
      sortable: true,
      sortField: "placas",
      width: "100px",
    },
    {
      chave: "statusAutorizacao",
      titulo: "Status autorização",
      selector: ({ statusAutorizacao }) => statusAutorizacao,
      cell: ({ statusAutorizacao }) =>
        statusAutorizacao === null
          ? SEM_VALOR
          : badgeStatus(chaveStatusAutorizacao(statusAutorizacao)),
      sortable: true,
      sortField: "statusAutorizacao",
      width: "170px",
    },
    {
      chave: "statusProducao",
      titulo: "Status produção",
      selector: ({ statusProducao }) => statusProducao,
      cell: ({ statusProducao }) =>
        statusProducao === null
          ? SEM_VALOR
          : badgeStatus(chaveStatusProducao(statusProducao)),
      sortable: true,
      sortField: "statusProducao",
      width: "160px",
    },
    {
      chave: "acoes",
      titulo: "Ações",
      selector: ({ id }) => id,
      cell: ({ id }) => (
        <FaEye
          style={{ cursor: "pointer" }}
          title="Visualizar lote"
          onClick={() => onVisualizar(id)}
        />
      ),
      width: "90px",
    },
  ];

  return (
    <TabelaPadrao
      titulo="Lotes criados"
      chaveConfigColunas="solicitacaoPlaca:lotes:colunas"
      limitarALargura
      colunas={colunas}
      dados={lotes}
      carregando={carregando}
      totalRegistros={totalRegistros}
      limite={limite}
      colunaOrdenadaInicial={ordenacaoInicial.campo}
      direcaoOrdenacaoInicial={ordenacaoInicial.direcao}
      paginaInicial={paginaInicial}
      reiniciarPaginacao={reiniciarPaginacao}
      onMudarPagina={onMudarPagina}
      onMudarLimite={onMudarLimite}
      onOrdenar={onOrdenar}
      onExportar={onExportar}
      exportando={exportando}
    />
  );
}
